import { Croissant } from "lucide-react";
import { useLang } from "@/i18n";
import { PHOTOS } from "@/photos";
import { FadeUp } from "./Reveal";

export default function Breakfast() {
  const { t } = useLang();

  return (
    <section id="colazione" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="breakfast-section">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
        <FadeUp className="relative">
          <div className="frame-clip overflow-hidden">
            <img
              src={PHOTOS.breakfast}
              alt={t.breakfast.title}
              loading="lazy"
              className="aspect-[4/5] w-full object-cover sm:aspect-[5/5]"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 flex items-center gap-3 rounded-3xl border border-pink-100 bg-white px-6 py-4 shadow-xl shadow-pink-600/10 sm:-right-8">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-pink-50 text-pink-600">
              <Croissant className="h-5 w-5" />
            </span>
            <img src="/logo.png" alt="Welcome Love House Roma" className="h-11 w-auto" />
          </div>
        </FadeUp>

        <FadeUp delay={0.15}>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-teal-700">{t.breakfast.eyebrow}</p>
          <h2 className="font-display mt-3 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl lg:text-5xl">
            {t.breakfast.title}
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-stone-500 sm:text-lg">{t.breakfast.body}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            {t.breakfast.chips.map((chip) => (
              <span
                key={chip}
                className="rounded-full border border-teal-600/25 bg-teal-50 px-5 py-2 text-sm font-semibold text-teal-800 transition-colors duration-300 hover:border-pink-400 hover:bg-pink-50 hover:text-pink-700"
              >
                {chip}
              </span>
            ))}
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
